import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, notification, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { Row, Form, Input, Col, Select, Collapse, Dropdown, Menu } from "antd";

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import { MinusCircleTwoTone, PlusCircleTwoTone, SearchOutlined, MoreOutlined, EditOutlined, ClearOutlined, FundViewOutlined, InfoCircleFilled, FileDoneOutlined, FireOutlined, PrinterOutlined } from "@ant-design/icons";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import ProductionApi from "../common/Apis/ProductionApi";
import AddTempHotHold from "../common/Models/HotHold/AddTemp";
import AddTemp from "../common/Models/AfterCook/AddTemp";
import CoolingProces from "../common/Models/CoolingProcess/AddTemp";
import StockLevel from "../common/Models/AfterCook/StockLevel";
import AftreCookApi from "../common/Apis/AftreCookApi";
import AddWaste from "../common/Models/Waste/AddWaste";
import AfterCooking from "../common/Models/AfterCook/AfterCooking";
import StockLevelApi from "../common/Apis/StockLevelApi";
import HistoryProduct from "../common/Models/Reheat/HistoryProduct";
import RecipeApi from "../common/Apis/RecipeApi";
import jsPDF from "jspdf";
import EmptyBox from "../common/CommonUI/EmptyBox";
import PrintLabel from "../common/Models/PrintLabel/PrintLabel";
import Pagination from "../common/Pagination/Pagination"; 
import "../common/Pagination/Pagination.css"; 

const AfterCook = () => {
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [formadd2] = Form.useForm();
  const [Production, setProduction] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [FilterEnable, setFilterEnable] = useState(true);
  const [totalElements, setTotalElements] = useState(0);
  const [searchText, setSearchText] = useState("");

  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });



    if (FilterEnable) {
      AftreCookApi.ListafterCook(0, value)
        .then((response) => {
          settotalPages(response.totalPages);
          setProduction(response.payloadDto);
          setTotalElements(response.totalElements);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      let singleLineString = filterRecipe
        .map((obj) => {
          if (obj.answerType === "%") {
            return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
          } else if (obj.answerType === "=") {
            return `${obj.title}${obj.answerType}${obj.name}`;
          } else {
            return `${obj.title}=BETWEEN${createDateTimestamp(
              obj.answerType
            )}AND${createDateTimestamp(obj.name)}`;
          }
        })
        .join("&");

      let filderData = window.btoa(
      "componentCode=AFTER_COOK&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
    );
      QuestionnairesApi.FilterQuestionsetNext(filderData, 0, value)
        .then((response) => {
          settotalPages(response.totalPages);
          setProduction(response.payloadDto);
          setTotalElements(response.totalElements);
        })
        .catch((err) => { });
    }
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1


    if (FilterEnable) {
      AftreCookApi.ListafterCook(pageNew, PaginateLimit)
        .then((response) => {
          setPaginatePage(pageNew)
          settotalPages(response.totalPages);
          setProduction(response.payloadDto);
          setTotalElements(response.totalElements);
        })
        .catch((err) => {
          console.log(err);
        });

    } else {

      let singleLineString = filterRecipe
        .map((obj) => {
          if (obj.answerType === "%") {
            return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
          } else if (obj.answerType === "=") {
            return `${obj.title}${obj.answerType}${obj.name}`;
          } else {
            return `${obj.title}=BETWEEN${createDateTimestamp(
              obj.answerType
            )}AND${createDateTimestamp(obj.name)}`;
          }
        })
        .join("&");

      let filderData = window.btoa(
      "componentCode=AFTER_COOK&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
    );
      QuestionnairesApi.FilterQuestionsetNext(filderData, pageNew, PaginateLimit)
        .then((response) => {
          setPaginatePage(pageNew)
          settotalPages(response.totalPages);
          setProduction(response.payloadDto);
          setTotalElements(response.totalElements);
        })
        .catch((err) => { });
    }
  };


  const getProduction = useCallback(() => {
    AftreCookApi.ListafterCook(PaginatePage, PaginateLimit).then((response) => {
      setProduction(response.payloadDto);
      settotalPages(response.totalPages);
      setTotalElements(response.totalElements);
    })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getProduction();
    PageLoading();
  }, [getProduction, PageLoading]);



  const handleRemovefilterProduction = (FiltergetProductionIndex) => {
    const newfilterProduction = [...filterRecipe];
    newfilterProduction.splice(FiltergetProductionIndex, 1);
    setFilterRecipe(newfilterProduction);
    if (FiltergetProductionIndex == 0) {
      getProduction();
    }
  };
  const handleClear = () => {
    getProduction();
    setFilterEnable(true);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterRecipe([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterRecipe, setFilterRecipe] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterRecipe = () => {
    setFilterRecipe([
      ...filterRecipe,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const handlePrintButtonClick2 = () => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [297, 210],
    });

    const fontSize = 10;


    let yPos = 35;
    doc.setFontSize(fontSize);

    const currentDate = new Date().toLocaleDateString();
    const currentTime = new Date().toLocaleTimeString();
    const promises = [];




    for (let i = 0; i < parseInt(PaginatetotalPages); i++) {
      if (FilterEnable) {

        promises.push(
          AftreCookApi.ListafterCook(i, PaginateLimit).then((response) => {
            doc.setFont('Poppins', 'bold');
            doc.text(`After Cook`, 150, 10, { align: 'center' });
            doc.setFont('Poppins', 'normal');
            doc.setFontSize(10);
            doc.text(`Date : ${currentDate}`, 10, 20);
            doc.text(`Time : ${currentTime}`, 10, 25);
            doc.setFontSize(fontSize);

            // Draw table headers and borders
            doc.setFont('Poppins', 'bold');
            doc.text('Date', 15, yPos);
            doc.text('Time', 40, yPos);
            doc.text('Product Description', 55, yPos);
            doc.text('Temp', 110, yPos);
            doc.text('Batch Code', 140, yPos);
            doc.text('OUBD', 180, yPos);
            doc.text('Sell By Date', 205, yPos);
            doc.text('Qty', 230, yPos);
            doc.text('Cooked by', 260, yPos);
            doc.setFont('Poppins', 'normal');
            doc.setLineWidth(0.1);
            doc.rect(12, yPos - 5, 280, 10);
            yPos += 10;



            response.payloadDto.forEach(row => {
              const date = formatDate(row?.dateOfCooking);
              const cookingTime = (row?.productionDTO?.cookingTime) ? convertTo12HourFormat(row?.productionDTO?.cookingTime) : '';
              const productionName = (row?.productionDTO?.productionName) ? row?.productionDTO?.productionName : row?.productionName;
              const temp = (row?.temp !== "N/A") ? row?.temp + ' °C' : "N/A";
              const batchCode = row?.productionDTO?.batchCode;
              const oubd = (row?.oubd) ? formatDate(row?.oubd) : '';
              const sellByDate = (row?.productionDTO?.sellByDate) ? formatDate(row?.productionDTO?.sellByDate) : '';
              const unit = (row?.quantityOfTheCookedProduct) ? row?.quantityOfTheCookedProduct + " " + row?.unit : '';
              const allergenInfo = row?.tenantDTO?.createdBy;

              doc.setFontSize(fontSize);

              doc.text(date, 15, yPos);
              doc.text(cookingTime, 40, yPos);
              doc.text(productionName, 55, yPos);
              doc.text(temp, 110, yPos);
              doc.text(batchCode, 140, yPos);
              doc.text(oubd, 180, yPos);
              doc.text(sellByDate, 205, yPos);
              doc.text(unit, 230, yPos);
              const allergenLines = doc.splitTextToSize(allergenInfo, 40);
              doc.text(allergenLines, 260, yPos);

              const rowHeight = 10 * Math.max(allergenLines.length, 1);

              if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                doc.addPage();
                yPos = 35; // Reset yPos for the new page
              } else {
                doc.setLineWidth(0.1);
                doc.rect(12, yPos - 5, 280, rowHeight);
                yPos += rowHeight;
              }
            });

            if (i === parseInt(PaginatetotalPages)) {
              doc.addPage();
              yPos = 35;
            }
          }).catch((err) => {
            console.log(err);
          })
        );
      } else {
        let singleLineString = filterRecipe
          .map((obj) => {
            if (obj.answerType === "%") {
              return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
            } else if (obj.answerType === "=") {
              return `${obj.title}${obj.answerType}${obj.name}`;
            } else {
              return `${obj.title}=BETWEEN${createDateTimestamp(
                obj.answerType
              )}AND${createDateTimestamp(obj.name)}`;
            }
          })
          .join("&");

        let filderData = window.btoa(
        "componentCode=AFTER_COOK&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
      );
        promises.push(
          QuestionnairesApi.FilterQuestionsetNext(filderData, i, PaginateLimit).then((response) => {
            doc.setFont('Poppins', 'bold');
            doc.text(`After Cook`, 150, 10, { align: 'center' });
            doc.setFont('Poppins', 'normal');
            doc.setFontSize(10);
            doc.text(`Date : ${currentDate}`, 10, 20);
            doc.text(`Time : ${currentTime}`, 10, 25);
            doc.setFontSize(fontSize);

            // Draw table headers and borders
            doc.setFont('Poppins', 'bold');
            doc.text('Date', 15, yPos);
            doc.text('Time', 40, yPos);
            doc.text('Product Description', 55, yPos);
            doc.text('Temp', 110, yPos);
            doc.text('Batch Code', 140, yPos);
            doc.text('OUBD', 180, yPos);
            doc.text('Sell By Date', 205, yPos);
            doc.text('Qty', 230, yPos);
            doc.text('Cooked by', 260, yPos);
            doc.setFont('Poppins', 'normal');
            doc.setLineWidth(0.1);
            doc.rect(12, yPos - 5, 280, 10);
            yPos += 10;



            response.payloadDto.forEach(row => {
              const date = formatDate(row?.dateOfCooking);
              const cookingTime = (row?.productionDTO?.cookingTime) ? convertTo12HourFormat(row?.productionDTO?.cookingTime) : '';
              const productionName = (row?.productionDTO?.productionName) ? row?.productionDTO?.productionName : row?.productionName;
              const temp = (row?.temp !== "N/A") ? row?.temp + ' °C' : "N/A";
              const batchCode = row?.productionDTO?.batchCode;
              const oubd = (row?.oubd) ? formatDate(row?.oubd) : '';
              const sellByDate = (row?.productionDTO?.sellByDate) ? formatDate(row?.productionDTO?.sellByDate) : '';
              const unit = (row?.quantityOfTheCookedProduct) ? row?.quantityOfTheCookedProduct + " " + row?.unit : '';
              const allergenInfo = row?.tenantDTO?.createdBy;

              doc.setFontSize(fontSize);

              doc.text(date, 15, yPos);
              doc.text(cookingTime, 40, yPos);
              doc.text(productionName, 55, yPos);
              doc.text(temp, 110, yPos);
              doc.text(batchCode, 140, yPos);
              doc.text(oubd, 180, yPos);
              doc.text(sellByDate, 205, yPos);
              doc.text(unit, 230, yPos);
              const allergenLines = doc.splitTextToSize(allergenInfo, 40);
              doc.text(allergenLines, 260, yPos);

              const rowHeight = 10 * Math.max(allergenLines.length, 1);

              if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                doc.addPage();
                yPos = 35; // Reset yPos for the new page
              } else {
                doc.setLineWidth(0.1);
                doc.rect(12, yPos - 5, 280, rowHeight);
                yPos += rowHeight;
              }
            });

            if (i === parseInt(PaginatetotalPages)) {
              doc.addPage();
              yPos = 35;
            }
          }).catch((err) => {
            console.log(err);
          })
        );
      }


    }

    const reversedPromises = promises.map(promise =>
      promise.then(result =>
        new Promise(resolve =>
          setTimeout(() => resolve(result), 0)
        )
      )
    );

    Promise.all(reversedPromises)
      .then(() => {
        window.open(doc.output('bloburl'), '_blank');
      })
      .catch((err) => {
        console.log(err);
      });

  };
  const handleSubmit = (data) => {
    setFilterEnable(false);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterRecipe
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=BETWEEN${createDateTimestamp(
            obj.answerType
          )}AND${createDateTimestamp(obj.name)}`;
        }
      })
      .join("&");

    let filderData = window.btoa(
      "componentCode=AFTER_COOK&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
    );
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setProduction(response.payloadDto);
        setTotalElements(response.totalElements);
      })
      .catch((err) => { });
  };


   const handleSubmit2 = (data) => {
    setFilterEnable(false);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);

        const searchFilter = searchText.trim()
          ? `&production.productionName=%${searchText.trim()}%`
          : "";


    let filderData = window.btoa(
      "componentCode=AFTER_COOK&subTenant.id=" + decodedToken?.subTenantId + "&"  + searchFilter
    );
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setProduction(response.payloadDto);
        setTotalElements(response.totalElements);
      })
      .catch((err) => { });
  };

  const createDateTimestamp = (Cdate) => {
    const date = new Date(Cdate);
    const unixTime = Math.floor(date.getTime());
    return unixTime;
  };
  const handleChangeTitle = (FiltergetproductionIndex, value) => {
    const newfilterProduction = [...filterRecipe];
    newfilterProduction[FiltergetproductionIndex].title = value;
    setFilterRecipe(newfilterProduction);

    const fieldName = 'name' + FiltergetproductionIndex;
    const fieldName2 = 'nameto' + FiltergetproductionIndex;
    formadd2.setFieldsValue({
      [fieldName]: null,
      [fieldName2]: null,
    });

  };
  const handleChangeAnswertype = (FiltergetproductionIndex, value) => {
    const newfilterProduction = [...filterRecipe];
    newfilterProduction[FiltergetproductionIndex].answerType = value;
    setFilterRecipe(newfilterProduction);
  };

  const handleChangename = (FiltergetproductionIndex, value) => {
    const newfilterProduction = [...filterRecipe];
    newfilterProduction[FiltergetproductionIndex].name = value;
    setFilterRecipe(newfilterProduction);
  };

  const paginatedData = Production;

  const [modalEditVisible, setModalEditVisible] = useState(false);
  const [modalEditData, setModalEditData] = useState("");
  const [modalEditafterIdData, setModalafterIdData] = useState(null);

  const handleOpenEditModal = (ProductionID, afterId) => {
    ProductionApi.SingleProduction(ProductionID)
      .then((response2) => {
        setModalEditData(response2.payload);
        setModalafterIdData(afterId);
      })
      .catch((err) => {
        console.log(err);
      });
    setModalEditVisible(true);
  };
  const handlEditeCloseModal = () => {
    setModalEditVisible(false);
  };


  const [modalCoodleVisible, setModalMoodleVisible] = useState(false);
  const [modalCoolingData, setModalCoolingData] = useState("");

  const handleOpenCoolingModal = (ProductionID) => {
    AftreCookApi.SingleafterCook(ProductionID)
      .then((response) => {
        ProductionApi.SingleProduction(response?.payload?.productionDTO?.id)
          .then((response2) => {
            setModalCoolingData(response2.payload);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
    setModalMoodleVisible(true);
  };

  const handlCoolingCloseModal = () => {
    setModalMoodleVisible(false);
  };


  const [modalwasteVisible, setModalwasteVisible] = useState(false);
  const [modalwasteData, setModalwasteData] = useState("");

  const handleOpenWasteModal = (ProductionID) => {
    ProductionApi.SingleProduction(ProductionID)
      .then((response2) => {
        setAfterCookId(response2.payload);
        setModalwasteData(response2.payload);
        RecipeApi.SingleRecipe(response2.payload?.recipeDTO?.id)
          .then((responseRecipe) => {
            setStockLevelIncreadiant(responseRecipe?.payload?.ingredientsDTO)
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
    StockLevelApi.ListStockProduction(ProductionID)
      .then((response) => {
        setStockLevelProducts(response?.payload[0])

      })
      .catch((err) => {
        console.log(err);
      });
    setModalwasteVisible(true);
  };

  const handlwasteCloseModal = () => {
    setModalwasteVisible(false);
  };


  const [modalHotHoldVisible, setModalHotHoldVisible] = useState(false);
  const [modalHotHoldData, setModalHotHoldData] = useState("");

  const handleOpenHotHoldModal = (ProductionID) => {
    ProductionApi.SingleProduction(ProductionID)
      .then((response2) => {
        setModalHotHoldData(response2.payload);
      })
      .catch((err) => {
        console.log(err);
      });
    console.log("modalHotHoldData", modalHotHoldData);
    setModalHotHoldVisible(true);
  };

  const handlHotHoldCloseModal = () => {
    setModalHotHoldVisible(false);
  };

  const [modalAfterCooking, setModalAfterCooking] = useState(false);

  const handleOpenAfterCooking = () => {
    setModalAfterCooking(true);
  }
  const handlAfterCookingCloseModal = () => {
    setModalAfterCooking(false);
  };

  const [modalHistoryVisible, setModalHistoryVisible] = useState(false);
  const [modalHistoryData, setModalHistoryData] = useState("");
  const [modalHistoryData2, setModalHistoryData2] = useState("");

  const handleOpenHistoryModal = (ProductionID) => {
  ProductionApi.SingleProduction(ProductionID)
    .then((response) => {
      // Encode the batch code to handle special characters like #
      const encodedBatchCode = encodeURIComponent(response?.payload?.batchCode);
      
      ProductionApi.SingleProductionHistory(encodedBatchCode)
        .then((response2) => {
          setModalHistoryData2(response?.payload);
          setModalHistoryData(response2.payload);
          setModalHistoryVisible(true);
        })
        .catch((err) => {
          console.log(err);
          if (err.apiError.status) {
            notification.open({
              message: <span style={{ fontWeight: "bold" }}>Error</span>,
              description: err.apiError.message,
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#fff2f0",
                color: "red",
              },
            });
          }
        });
    })
    .catch((err) => {
      console.log(err);
    });
};

  const handlHistoryCloseModal = () => {
    setModalHistoryVisible(false);
  };

  const [modalStockLevel, setModalStockLevel] = useState(false);
  const [AfterCookId, setAfterCookId] = useState("");
  const [StockLevelProducts, setStockLevelProducts] = React.useState();
  const [StockLevelIncreadiant, setStockLevelIncreadiant] = React.useState([]);

  const handleOpenStockLevel = (CookId) => {
    ProductionApi.SingleProduction(CookId)
      .then((response2) => {
        setAfterCookId(response2.payload);
        RecipeApi.SingleRecipe(response2.payload?.recipeDTO?.id)
          .then((responseRecipe) => {
            setStockLevelIncreadiant(responseRecipe?.payload?.ingredientsDTO)
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
    StockLevelApi.ListStockProduction(CookId)
      .then((response) => {
        setStockLevelProducts(response?.payload[0])

      })
      .catch((err) => {
        console.log(err);
      });
    setModalStockLevel(true);
  }
  const handlStockLevelCloseModal = () => {
    setModalStockLevel(false);
  };
  const [allergens, setAllergens] = useState(null);

  const fetchAllergens = (id) => {
    ProductionApi.SingleProduction(id)
      .then((response) => {
        setAllergens(response?.payload?.allergensDTO);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlPrintLabelCloseModal = () => {
    setModalPrintLabelVisible(false);
  };

  function compareDates(creationDate) {
    const today = new Date();
    const itemDate = new Date(creationDate);
    return itemDate >= today;
  }

  const [modalPrintLabelVisible, setModalPrintLabelVisible] = useState(false);
  const [modalPrintLabelData, setModalPrintLabelData] = useState("");
  const [modalPrintLabelProductionData, setModalPrintLabelProductionData] = useState("");

  // const handleOpenPrintLabelModal = (CookingId) => {
  //   ProductionApi.SingleProduction(CookingId)
  //     .then((response2) => {
  //       setModalPrintLabelProductionData(response2.payload);
  //       setModalPrintLabelData(response2.payload);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });

  //   setModalPrintLabelVisible(true);
  // };

  const handleOpenPrintLabelModal = (aftercookId) => {
    AftreCookApi.SingleafterCook(aftercookId)
      .then((response) => {
        ProductionApi.SingleProduction(response?.payload?.productionDTO?.id)
          .then((response2) => {
            setModalPrintLabelProductionData(response2.payload);
            setModalPrintLabelData(response.payload);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });

    setModalPrintLabelVisible(true);
  };

  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">
          <td style={{ width: "8%" }} className="pt-3">
            {formatDate(item?.dateOfCooking)}
          </td>
          <td style={{ width: "5%" }} className="pt-3 ">
            {convertTo12HourFormat(item?.productionDTO?.cookingTime)}
          </td>
          <td style={{ width: "12%" }} className="pt-3 ">
            {(item?.productionDTO?.productionName) ? item?.productionDTO?.productionName : item?.productionName}
          </td>
          <td style={{ width: "4%" }} className="pt-3">
            {item?.temp !== "N/A" ? item?.temp + ' °C' : "N/A"}
          </td>
          <td style={{ width: "12%" }} className="pt-3">
          <div style={{
            overflowX: 'auto',
            overflowY: 'hidden',
            whiteSpace: 'nowrap',
            maxWidth: '200px',
            marginBottom: '10px',
            marginTop: '-3px',
            padding: '0px 0px 20px',
            display: 'block',
            }}>
            {item?.productionDTO?.batchCode}
          </div>                           
          </td>
          <td style={{ width: "8%" }} className="pt-3">
            {(item?.oubd) ? formatDate(item?.oubd) : ''}
          </td>
          <td style={{ width: "8%" }} className="pt-3">
            {formatDate(item?.productionDTO?.sellByDate)}
          </td>
          <td style={{ width: "4%", textAlign: "end" }} className="pt-3 ">
            {parseFloat(item?.quantityOfTheCookedProduct).toFixed(2)}&nbsp;{item?.unit}
          </td>
          <td style={{ width: "12%" }} className="pt-3">
            {item?.createdBy}
          </td>
          <td style={{ width: "4%" }} className="pt-3 text-center">
            <Tooltip
              placement="top"
              title={allergens ? (
                <div>
                  {allergens.map((allergen, index) => (
                    <div key={index}>{allergen.allergensName}</div>
                  ))}
                </div>
              ) : null}
              onMouseEnter={() => fetchAllergens(item?.productionDTO?.id)} // Trigger API call on mouse hover
            >
              <InfoCircleFilled className="inforIcon" />
            </Tooltip>
          </td>
          <td style={{ width: "4%", textAlign: "center" }} className="pt-3 ">
            {item?.description &&
              <Tooltip placement="top" title={(
                <div>
                  {item?.description}
                </div>
              )}>
                <FileDoneOutlined className="inforIcon" />
              </Tooltip>
            }
          </td>
          <td style={{ width: "5%" }}>

            <div className="d-flex justify-content-center">
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      key="Take"
                      onClick={() => handleOpenEditModal(item?.productionDTO?.id, item)}
                    >
                      <EditOutlined /> Take Temp
                    </Menu.Item>

                    <Menu.Item
                      key="Stock"
                      // className={`${item?.temp !== "N/A" ? "" : "d-none"}`}
                      onClick={() => handleOpenStockLevel(item?.productionDTO?.id)}>
                      <FundViewOutlined /> Stock Level
                    </Menu.Item>

                    <Menu.Item
                      key="Cooling"
                      // className={`${item?.temp !== "N/A" ? "" : "d-none"}`}
                      onClick={() => handleOpenCoolingModal(item?.id)}>
                      <SearchOutlined /> Cooling Process
                    </Menu.Item>
                    <Menu.Item
                      key="Waste"
                      // className={`${item?.temp !== "N/A" ? "" : "d-none"}`}
                      onClick={() => handleOpenWasteModal(item?.productionDTO?.id)}>
                      <ClearOutlined /> Waste
                    </Menu.Item>
                    <Menu.Item
                      key="HotHold"
                      onClick={() => handleOpenHotHoldModal(item?.productionDTO?.id)}>
                      <FireOutlined /> Hot Hold
                    </Menu.Item>

                    <Menu.Item
                      key="History"
                      onClick={() => handleOpenHistoryModal(item?.productionDTO?.id)}>
                      <SearchOutlined /> History of Product
                    </Menu.Item>

                    <Menu.Item
                      key="Cooling"
                      className={compareDates(item?.productionDTO?.sellByDate) ? '' : 'd-none'}
                      onClick={() => handleOpenPrintLabelModal(item?.id)}>
                      <PrinterOutlined /> Print Label
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
                placement="bottom"
              >
                <div className="action-circle">
                  <MoreOutlined />
                </div>
              </Dropdown>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={12} className="text-center">
            <EmptyBox />
            <br />
            <Link to={'/production'}>
              <Button
                type="primary"
                style={{
                  display: decodedToken?.permissions?.some(
                    permission => permission?.authority === 'ADD_PRODUCT'
                  ) ? '' : 'none',
                  height: 'auto',
                  lineHeight: 'normal',
                  alignItems: 'center',
                  padding: '5px 24px',
                }}
              >
                Add Production
              </Button>
            </Link>
          </td>
        </tr>
      );
    }
  };
  function convertTo12HourFormat(timeString) {
    if (!timeString) return '';

    const [hours, minutes] = timeString.split(':');
    let formattedTime = '';

    let formattedHours = parseInt(hours, 10);
    const ampm = formattedHours >= 12 ? 'PM' : 'AM';
    formattedHours = formattedHours % 12 || 12;

    const formattedMinutes = minutes.padStart(2, '0');

    formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
    return formattedTime;
  }
  function formatDate(date) {
    const dateNew = parseInt(date, 10);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(dateNew).toLocaleDateString(
      "en-US",
      options
    );

    const [month, day, year] = formattedDate?.split(" ");
    const capitalizedMonth = month.toUpperCase();
    return `${day} ${capitalizedMonth} ${year}`;
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader onPrintResponse2={handlePrintButtonClick2} />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            form={formadd2}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
               <Panel
                  header={
                    
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        width: "100%",
                      }}
                    >
                      <h5 className="mb-0" style={{ whiteSpace: "nowrap", marginRight: "500px" }}>
                        <b>Filter</b>
                      </h5>

                      <Input
                        placeholder="Quick Product Search..."
                        allowClear
                        style={{ width: 300 }}
                        onChange={(e) => setSearchText(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                      />
                        <Button
                        style = {{width: "100px"}}
                        type="primary"
                        htmlType="submit"
                        className="btn btn-primary btn-save table-action icon-center"
                        onClick={
                          (e) => {
                            e.stopPropagation();
                            handleSubmit2();
                          }
                        }
                      >
                        Filter
                      </Button>                          
                    </div>
                  }
                  key="1"
                >
                  {filterRecipe.map((input, filterProductionIndex) => (
                    <div key={filterProductionIndex}>
                      <Row gutter={24} className="pt-2">
                        <Col lg={5} md={5} className="px-1">
                          <Form.Item
                            name={`title${filterProductionIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterProductionIndex, value)
                              }
                              options={[
                                {
                                  value: "dateOfCooking",
                                  label: "Cooked Date",
                                },
                                {
                                  value: "production.productionName",
                                  label: "Product Description",
                                },
                                {
                                  value: "production.sellByDate",
                                  label: "Sell By Date",
                                },
                                {
                                  value: "production.batchCode",
                                  label: "Batch Code",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col lg={4} md={4} className="px-1">
                          {filterRecipe[filterProductionIndex].title ==
                            "dateOfCooking" || filterRecipe[filterProductionIndex].title ==
                            "production.sellByDate" ? (
                            <>
                              <Form.Item
                                name={`nameto${filterProductionIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  placeholder="Filter By"
                                  onChange={(e) =>
                                    handleChangeAnswertype(
                                      filterProductionIndex,
                                      e.target.value
                                    )
                                  }
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`type${filterProductionIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  placeholder="Condition"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      filterProductionIndex,
                                      value
                                    )
                                  }
                                  options={[
                                    { value: "%", label: "Matches with" },
                                    {
                                      value: "=",
                                      label: "Equals to",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>


                        <Col lg={5} md={5} className="px-1">
                          {filterRecipe[filterProductionIndex].title ==
                            "dateOfCooking" || filterRecipe[filterProductionIndex].title ==
                            "production.sellByDate" ? (
                            <>
                              <Form.Item
                                name={`name${filterProductionIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select End Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterProductionIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          ) : (
                            <>
                              <Form.Item
                                name={`name${filterProductionIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Text.",
                                  },
                                ]}
                              >
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterProductionIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>


                        <Col lg={8} md={10} className="px-1">
                          <Form.Item className="text-lable">
                            {filterProductionIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterRecipe}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterProduction(
                                      filterProductionIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>

            <div className="d-flex justify-content-between align-items-center">
              <div>
                {/* {paginatedData?.length > 0 && (
                  <Link
                    className={decodedToken?.permissions?.some(
                      (permission) => permission?.authority === 'ADD_PRODUCTION'
                    ) ? 'btn btn-primary btn-save m-0 my-2' : 'd-none'}
                    to={'/stock-list'}
                  >
                    See Inventory
                  </Link>
                )} */}
                {/* <Link
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'ADD_PRODUCTION'
                  ) ? 'btn btn-primary btn-save m-0 mx-2 my-2' : 'd-none'}
                  onClick={() => handleOpenAfterCooking()}
                  style={{ width: '250px' }}
                >
                  Add to After Cook
                </Link> */}
                {/* <Link
                  className={'btn btn-primary btn-save m-0 mx-2 my-2'}
                  onClick={() => handleOpenAfterCooking()}
                  style={{ width: '250px' }}
                >
                  <Button
                    type="primary"
                    style={{
                      display: "block",
                      height: "auto",
                      lineHeight: "normal",
                      alignItems: "center",
                      padding: "5px 24px",
                    }}
                  >
                   Add to After Cook
                  </Button>
                </Link> */}
                <Link onClick={() => handleOpenAfterCooking()}>
                  <Button
                    type="primary"
                    style={{
                      display: decodedToken?.permissions?.some(
                        (permission) => permission?.authority === "ADD_PRODUCT"
                      )
                        ? "block"
                        : "none",
                      height: "auto",
                      lineHeight: "normal",
                      alignItems: "center",
                      padding: "5px 24px",
                    }}
                  >
                    Add to After Cook
                  </Button>
                </Link>
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Product Description</th>
                  <th>Temp</th>
                  <th>Batch Code</th>
                  <th className="text-center" >OUBD<br /> <p className="mb-0 pb-0" style={{ color: 'gray', fontSize: '12px' }}>(Original Used by Date)</p></th>

                  <th>Sell By Date</th>
                  <th className="text-end">Qty</th>
                  <th>Cooked by</th>
                  <th>Allergens</th>
                  <th className="text-center">Corrective Action</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>

            {paginatedData.length > 0 && (
              <Pagination
                currentPage={currentPage}
                totalPages={PaginatetotalPages}
                onPageChange={handlePageChange}
                maxVisiblePages={5}
                showPageInfo={true}
                totalItems={totalElements}
                pageSize={PaginateLimit}
              />
            )}

          </div>
        </Content>
        {modalEditVisible &&
          <AddTemp
            visible={modalEditVisible}
            onClose={handlEditeCloseModal}
            ProductDetails={modalEditData}
            AfterID={modalEditafterIdData}
          />
        }
        {modalStockLevel &&
          <StockLevel
            visible={modalStockLevel}
            onClose={handlStockLevelCloseModal}
            afterCookId={AfterCookId}
            StockLevelProducts={StockLevelProducts}
            StockLevelIncreadiant={StockLevelIncreadiant}
          />
        }

        {modalAfterCooking &&
          <AfterCooking
            visible={modalAfterCooking}
            onClose={handlAfterCookingCloseModal}
          />
        }

        {modalCoodleVisible &&
          <CoolingProces
            visible={modalCoodleVisible}
            onClose={handlCoolingCloseModal}
            afterCookId={modalCoolingData}
          />
        }

        {modalwasteVisible &&
          <AddWaste
            visible={modalwasteVisible}
            onClose={handlwasteCloseModal}
            ProductionDetails={modalwasteData}
            ingredientDetails={StockLevelIncreadiant}
          />
        }

        {modalHotHoldVisible &&
          <AddTempHotHold
            visible={modalHotHoldVisible}
            onClose={handlHotHoldCloseModal}
            ProductctionDetails={modalHotHoldData}
          />
        }

        {modalPrintLabelVisible && <PrintLabel
          visible={modalPrintLabelVisible}
          onClose={handlPrintLabelCloseModal}
          CoolingProcess={modalPrintLabelData}
          ProductionData={modalPrintLabelProductionData}
        />}

        {modalHistoryVisible &&
          <HistoryProduct
            visible={modalHistoryVisible}
            onClose={handlHistoryCloseModal}
            ProductionData={modalHistoryData}
            ProductionData2={modalHistoryData2}
          />
        }
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default AfterCook;
